/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="13.8"
        height="18.98"
        viewBox="0 0 13.8 18.98"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M0 18.98h13.8V5.19L8.62.04H.04ZM8.87 1.7l3.21 3.2H8.87ZM1 1h6.87v4.9h4.93v12.08H1Zm8.67 9.13a2.77 2.77 0 1 0-5.08 1.51L2.7 14.55l1.86-.09.72 1.63 1.62-2.65 1.62 2.65.67-1.59 1.87.09-1.89-2.9a2.74 2.74 0 0 0 .46-1.52Zm-4.25 3.8-.22-.51h-.6l.69-1.05.38.22a3.66 3.66 0 0 0 .46.18Zm1.82-2.07a2 2 0 0 1-.34 0 1.76 1.76 0 1 1 .67-.13l-.33.09Zm1.35 1.56-.22.51-.7-1.15.31-.11h.14c.09 0 .17-.1.25-.14l.13-.08.69 1.05Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'PaperFoldedCornerWithNotaryIcon';

export default Icon;
